module.exports = __webpack_public_path__ + "static/hacibaba-kuruyemis-sm-f6ed76d44bff3e597cd3dd0972b5f656.jpg";